export default "__VITE_ASSET__DSiH0s37__"